<template>
  <b-card class="mb-4 shadow">
    <div class="text-align" style="user-select:none">
      <b-spinner v-if="state === 'loading'" />
      <span v-if="state === 'error'" class="text-warning">Error getting file size information</span>
    </div>

    <b-table-lite v-if="sizes" :items="sizes" small head-variant="light" foot-clone>
      <template v-slot:cell(size)="{value}">{{value | niceBytes}}</template>
      <template v-slot:foot(artifact)>
        <i>Total size</i>
      </template>
      <template v-slot:foot(size)>
        <i>{{totalBytes | niceBytes}}</i>
      </template>
    </b-table-lite>
  </b-card>
</template>

<script>

import * as bs from 'bootstrap-vue';
import Vue from 'vue';

[
    bs.TableLitePlugin,
    bs.SpinnerPlugin,
    bs.CardPlugin,
].forEach(p=> Vue.use(p))

export default {
  props: ["job-id"],
  data() {
    return {
      sizes: null,
      state: "loading"
    };
  },
  created() {
    this.state = "data";
  },
  computed: {
    totalBytes() {
      return this.sizes.map(v => parseInt(v.size)).reduce((v,t)=>v+t, 0);
    }
  },
  watch: {
    jobId() {
      this.sizes = null;
      this.state = "loading";
      let self = this;
      this.$nextTick(() => (self.state = "data"));
    },
    state(newState) {
      if (newState == "data" && this.sizes === null) this.updateData();
    }
  },
  methods: {
    updateData() {
      let self = this;
      this.$api
        .jobSize(this.jobId)
        .then(t => {
          self.sizes = t
            .trim()
            .split("\n")
            .slice(1)
            .map(l => {
              let [size, artifact] = l.split("\t");
              return { artifact, size };
            });
        })
        .catch(() => (self.state = "error"));
    }
  }
};
</script>

<style>
</style>